import React from 'react';
import { Modal } from 'antd';
import styled from '@emotion/styled';
import { CloseCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { TitleModal } from '../../molecules/modal/TitleModal';
import { appStyles } from '../../../styles';
import { PROMOTION } from '../../../constants/define/translation';
import { WIDTH_MODAL } from '../../../constants/common';
import { FormScheduleTile } from './forms/FormScheduleTile';

interface FormProductTileModalProps {
  isOpenModal: boolean;
  onClose: () => void;
  record?: any;
  setDataRecord: Function;
}

export const FormScheduleTileModal = (props: FormProductTileModalProps) => {
  const { isOpenModal, onClose, record, setDataRecord } = props;
  const { t } = useTranslation(PROMOTION);
  return (
    <StyledModal
      title={<TitleModal title={t('form.scheduleTile')} />}
      centered
      visible={isOpenModal}
      width={WIDTH_MODAL}
      footer={null}
      onCancel={() => {
        onClose();
        setDataRecord(null);
      }}
      maskClosable={false}
      closeIcon={<CloseCircleOutlined />}
      forceRender
    >
      <FormScheduleTile record={record} onClose={onClose} />
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  & > .ant-modal-content {
    ${appStyles.commonModalContentStyle}
  }

  .site-card-wrapper {
    ${appStyles.background.modalBgGray}
    & .card-item {
      text-align: center;
      padding: 1rem;
    }
  }

  & h4.ant-typography {
    ${appStyles.color.black}
  }

  .ant-modal-header {
    padding-left: 0;
  }

  .card-item .ant-image {
    cursor: pointer;
  }

  & .card-up-to-date {
    & .ant-image {
      padding: 0px;
      margin-left: 12px;
      & img {
        width: 92%;
        padding: 5px 0 0px 0;
      }
    }
  }
`;
